export default __webpack_public_path__ + "static/media/magicflex.ac7fd4ee.png";